import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import useService from "../../../../hooks/useService";
import { findRawRecords } from "../../../../services/crudService";
import { PERMITS_QUERY_KEY, QUERY_OPTIONS } from "../constants";

/**
 * Custom hook for fetching and filtering permit data
 *
 * @returns {Object} Permit data state and handlers
 */
const usePermitData = () => {
  const service = useService({ toast: false });

  // Selection state for MaterialTable
  const [selectedRows, setSelectedRows] = useState([]);

  // Year filter state
  const [yearsOptions, setYearsOptions] = useState([]);
  const [selectedYears, setSelectedYears] = useState([]);
  const [filteredData, setFilteredData] = useState(null);

  // Fetch permit data
  const { data, isLoading, error } = useQuery(
    [PERMITS_QUERY_KEY],
    async () => {
      try {
        return await service([findRawRecords, [PERMITS_QUERY_KEY]]);
      } catch (err) {
        console.error(err);
        throw err;
      }
    },
    QUERY_OPTIONS
  );

  // Extract distinct years when data loads
  useEffect(() => {
    if (data?.length > 0) {
      const distinctYears = [...new Set(data.map((item) => item.permit_year))];
      setYearsOptions(distinctYears);
      setSelectedYears([distinctYears[0]] ?? []);
    }
  }, [data]);

  // Filter data by selected years
  useEffect(() => {
    if (data) {
      setFilteredData(
        data.filter((item) => selectedYears.includes(item.permit_year))
      );
      setSelectedRows([]); // Clear selection when filter changes
    }
  }, [selectedYears, data]);

  return {
    filteredData,
    isLoading,
    error,
    yearsOptions,
    selectedYears,
    setSelectedYears,
    selectedRows,
    setSelectedRows,
  };
};

export default usePermitData;
